import * as React from "react";
import { CSSTransition, TransitionGroup } from "react-transition-group";
import { DocumentManager, File } from "../../DocumentManager";
import { IBaseSubSectionProps } from "./IBaseSubSectionProps";
import { IToolProps } from "../Tool";

export interface ISmartBoardsSubSectionState {
    list: Array<{ id: string; name: string }>;
}

export class SmartBoardsSubSection extends React.Component<
    IBaseSubSectionProps,
    ISmartBoardsSubSectionState
> {
    constructor(props: IBaseSubSectionProps) {
        super(props);

        this.state = {
            list: null,
        };

        if (this.props.tools.length === 1) {
            this._smartBoardsApplication = this.props.tools[0];
        }
    }

    componentDidMount(): void {
        void this._getBoards();
        window.addEventListener(`message`, this._eventListener);
    }

    componentWillUnmount(): void {
        window.removeEventListener(`message`, this._eventListener);
    }

    private readonly _smartBoardsApplication: IToolProps;

    private readonly _getBoards = async (): Promise<void> => {
        const stringResult: string = await $.ajax({
            method: `GET`,
            url: `/SmartTools/MyDashboards`,
        });

        const result: ISmartBoardsSubSectionState = JSON.parse(stringResult);

        this.setState(result);
    };

    private readonly _bindSmartBoard = (file: File): void => {
        const newToolUrl = `${this._smartBoardsApplication.url}/${file.id}`;

        this.props.bindToolToFrame(
            this._smartBoardsApplication.moduleID,
            this._smartBoardsApplication.name,
            this._smartBoardsApplication.lookupName,
            newToolUrl,
        );
    };

    private readonly _openExplorer = (): void => {
        const newToolUrl = `${
            this._smartBoardsApplication.rootUrl ??
            this._smartBoardsApplication.url
        }/manager`;

        this.props.bindToolToFrame(
            this._smartBoardsApplication.moduleID,
            this._smartBoardsApplication.name,
            this._smartBoardsApplication.lookupName,
            newToolUrl,
        );
    };

    private readonly _bindNewBoard = (): void => {
        this.props.bindToolToFrame(
            this._smartBoardsApplication.moduleID,
            this._smartBoardsApplication.name,
            this._smartBoardsApplication.lookupName,
            this._smartBoardsApplication.url,
        );
    };

    private readonly _eventListener = (event: MessageEvent): void => {
        if (event.data === `SmartBoards:Refresh`) {
            void this._getBoards();
        }
    };

    private _searchDocs(
        list: Array<{ id: string; name: string }>,
        searchQuery: string,
    ): Array<{ id: string; name: string }> {
        if (list) {
            return list.filter((t) =>
                t.name.toLowerCase().includes(searchQuery.toLowerCase()),
            );
        } else {
            return list;
        }
    }

    private readonly _refresh = (): void => {
        void this._getBoards();
    };

    render(): React.ReactElement {
        const filteredDocs: Array<{ id: string; name: string }> =
                this._searchDocs(this.state.list, this.props.searchQuery),
            subSectionClass = `section-subsection smartboards`;

        return (
            <CSSTransition
                classNames={`section-subsection`}
                in={this.props.isActive}
                timeout={200}
            >
                <div className={subSectionClass}>
                    <div className={`subsection-title`}>{this.props.name}</div>
                    <TransitionGroup component={null}>
                        {this.props.isActive && (
                            <CSSTransition
                                classNames={`subsection-toolcontainer`}
                                in={this.props.isActive}
                                timeout={200}
                            >
                                <div
                                    className={`subsection-toolcontainer`}
                                    style={{
                                        display: `flex`,
                                        height: `400px`,
                                    }}
                                >
                                    <DocumentManager
                                        bindFile={this._bindSmartBoard}
                                        bindNewDashboard={this._bindNewBoard}
                                        documents={filteredDocs}
                                        openExplorer={this._openExplorer}
                                        refresh={this._refresh}
                                        smartBoardsUrl={
                                            this._smartBoardsApplication.url
                                        }
                                    />
                                </div>
                            </CSSTransition>
                        )}
                    </TransitionGroup>
                </div>
            </CSSTransition>
        );
    }
}
